import { createAsyncThunk } from "@reduxjs/toolkit";
import { getFirebaseAuthToken } from "../../helpers/firebase_helper";
const API_BASE = process.env.REACT_APP_API_BASE_URL;

// GET individuals : GET /individuals

export const getIndividuals = createAsyncThunk(
  "individuals/getIndividuals",
  async ({ role, status, page, query = "" }) => {
    try {
      const token = await getFirebaseAuthToken();
      const response = await fetch(
        `${API_BASE}/${role}/individuals?status=${status}&page=${page}&query=${query}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `${token}`,
          },
        }
      );
      if (!response.ok) {
        throw new Error("Error fetching individuals");
      }
      const data = await response.json();
      return data;
    } catch (error) {
      console.log(error);
    }
  }
);

export const getIndividualsByUserId = createAsyncThunk(
  "individuals/getIndividualsByUserId",
  async ({ userId, page, status, query = "" }) => {
    try {
      const token = await getFirebaseAuthToken();
      const response = await fetch(
        `${API_BASE}/dashboard/user/individuals/${userId}?status=${status}&page=${page}&query=${query}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `${token}`,
          },
        }
      );
      if (!response.ok) {
        throw new Error("Error fetching individuals");
      }
      const data = await response.json();
      return data;
    } catch (error) {
      console.log(error);
    }
  }
);

// POST individuals : POST /individuals

export const addIndividual = createAsyncThunk(
  "individuals/createIndividual",
  async ({ data }) => {
    try {
      const token = await getFirebaseAuthToken();
      const response = await fetch(`${API_BASE}/dashboard/individuals`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `${token}`,
        },
        body: JSON.stringify(data),
      });
      const res = await response.json();
      return res;
    } catch (error) {
      console.log(error);
    }
  }
);
export const getCommissionRecordsByUserId = createAsyncThunk(
  "individuals/getCommissionRecordsByUserId",
  async ({ userId, page }) => {
    try {
      const token = await getFirebaseAuthToken();
      const response = await fetch(
        `${API_BASE}/dashboard/commission-records/individuals/${userId}?page=${page}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `${token}`,
          },
        }
      );
      if (!response.ok) {
        throw new Error("Error fetching individuals");
      }
      const data = await response.json();
      return data;
    } catch (error) {
      console.log(error);
    }
  }
);
